import * as React from "react";
import { CreditCard, Truck, RefreshCcw, Mail, MessageCircleQuestionMark } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
const categories = [{
  id: "payments",
  title: "Implementering",
  icon: CreditCard
}, {
  id: "shipping",
  title: "AI Funksjonalitet",
  icon: Truck
}, {
  id: "returns",
  title: "Sikkerhet & Data",
  icon: RefreshCcw
}];
const faqs = [{
  id: "p1",
  categoryId: "payments",
  question: "Hvor lang tid tar det å sette opp Xora?",
  answer: "Vi kan ha din første AI-agent operativ i løpet av 48 timer. Full integrasjon med ditt CRM-system tar vanligvis mellom 5 til 10 arbeidsdager avhengig av kompleksitet."
}, {
  id: "p2",
  categoryId: "payments",
  question: "Krever det teknisk kompetanse fra meg?",
  answer: "Nei, Xora er bygget for å være 'plug-and-play'. Vårt team håndterer all teknisk oppsett og integrasjon, slik at du kan fokusere på å selge eiendom."
}, {
  id: "p3",
  categoryId: "payments",
  question: "Kan jeg endre prisplan senere?",
  answer: "Absolutt. Du kan oppgradere eller nedgradere din plan når som helst. Endringer vil tre i kraft fra neste faktureringsperiode."
}, {
  id: "s1",
  categoryId: "shipping",
  question: "Hvilke oppgaver kan AI-en automatisere?",
  answer: "Xora håndterer alt fra møtebooking og oppfølging av interessenter til generering av prospekt-tekster og automatisk svar på vanlige spørsmål via SMS og e-post."
}, {
  id: "s2",
  categoryId: "shipping",
  question: "Lærer AI-en av mine tidligere salg?",
  answer: "Ja, våre Proff- og Ultimat-pakker inkluderer maskinlæring som analyserer din historiske data for å toneangivende kommunikasjon som matcher din personlige stil."
}, {
  id: "r1",
  categoryId: "returns",
  question: "Er dataene mine trygge hos Xora?",
  answer: "Sikkerhet er vår høyeste prioritet. Vi bruker bank-nivå kryptering og er fullt ut GDPR-kompatible. Dine data blir aldri brukt til å trene modeller for andre kunder."
}, {
  id: "r2",
  categoryId: "returns",
  question: "Hvem eier innholdet AI-en genererer?",
  answer: "Du eier 100% av alt innhold, tekster og data som genereres gjennom Xora-plattformen. Vi er kun din tekniske leverandør."
}];
export default function FaqSection() {
  return <section data-section-id="224891" id="ofte-stilte-spørsmål" className="w-full py-16 md:py-24 bg-background text-foreground">
      <div className="container mx-auto px-4 md:px-6 max-w-4xl">
        
        {}
        <div className="text-center mb-12 md:mb-16">
          <div className="inline-flex items-center justify-center p-3 bg-primary/10 rounded-full mb-4 backdrop-blur-sm border border-primary/20">
            <MessageCircleQuestionMark className="size-6 text-primary" />
          </div>
          <h2 className="font-default text-3xl md:text-5xl font-bold tracking-tighter mb-4 text-white">
            Ofte stilte spørsmål
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto font-default">
            Alt du trenger å vite om hvordan Xora revolusjonerer hverdagen for eiendomsmeglere med intelligent AI-automasjon.
          </p>
        </div>

        {}
        <div className="space-y-12">
          {categories.map((category, i) => {
          const categoryFaqs = faqs.filter(faq => faq.categoryId === category.id);
          const Icon = category.icon;
          return <div key={category.id} data-index={i} className="bg-card/40 backdrop-blur-md rounded-3xl p-6 md:p-8 shadow-2xl border border-white/10 hover:border-primary/30 transition-all duration-500">
                <div className="flex items-center gap-3 mb-6 pb-4 border-b border-white/5">
                  <div className="p-2 bg-primary/20 rounded-xl">
                    <Icon className="size-5 text-accent" />
                  </div>
                  <h3 className="font-default text-xl font-bold text-white tracking-tight">
                    {category.title}
                  </h3>
                </div>

                <Accordion type="single" collapsible className="w-full">
                  {categoryFaqs.map((faq, j) => <AccordionItem key={faq.id} value={faq.id} data-index={j} className="border-white/5 last:border-0">
                      <AccordionTrigger className="text-left font-default font-semibold text-base text-white hover:text-primary transition-colors py-4 data-[state=open]:text-primary">
                        {faq.question}
                      </AccordionTrigger>
                      <AccordionContent className="text-muted-foreground font-default leading-relaxed pb-5 animate-in fade-in slide-in-from-top-2 duration-300">
                        {faq.answer}
                      </AccordionContent>
                    </AccordionItem>)}
                </Accordion>
              </div>;
        })}
        </div>

        {}
        

      </div>
    </section>;
}